import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-odata-comuni',
  templateUrl: './odata-comuni.component.html',
  styleUrls: ['./odata-comuni.component.css']
})
export class OdataComuniComponent implements OnInit {
  dataSource: any;

  constructor() {
    
    this.dataSource = {
      store: {
        type: 'odata',
        url: 'http://rentrincloud.it:8080/api/comune/getodata',
        key: 'id',
      },
      /*select: [
        'id',
        'Descrizione',
        'SiglaProvincia',
        'CAP',
        'Catasto',
      ],*/
      /*filter: ['Product_Current_Inventory', '>', 0],*/
    };
   }

  ngOnInit() {
  }

}
